/* Pure Cartel — product page interactions */
/* ---------- mobile review cards: clamp long reviews ----------
   Deliberately its own IIFE, placed BEFORE the main one below. The clamp HIDES
   review text, so the button that reopens it must not depend on ~700 lines
   of unrelated code running without throwing first.

   The clamp is applied by JS (.is-clampable) rather than living in the
   stylesheet, so if this never runs the reviews render in full — tall, but
   readable — instead of truncated with no way to expand. The rest of the
   mobile card compaction is pure CSS and applies either way. */
(function () {
  const init = () => {
  const list = document.getElementById("reviewList");
  if (!list) return;

  const rows = Array.from(list.querySelectorAll(".revrow"));
  rows.forEach((row) => row.classList.add("is-clampable"));

  const sync = () => {
    rows.forEach((row) => {
      if (row.classList.contains("is-expanded")) return;
      const text = row.querySelector(".revrow__text");
      const btn = row.querySelector(".revrow__readmore");
      if (!text || !btn) return;
      btn.classList.toggle("is-needed", text.scrollHeight > text.clientHeight + 1);
    });
  };

  list.addEventListener("click", (e) => {
    const btn = e.target.closest(".revrow__readmore");
    if (!btn) return;
    const row = btn.closest(".revrow");
    const open = row.classList.toggle("is-expanded");
    btn.textContent = open ? "Show less ←" : "Read more →";
  });

  sync();
  window.addEventListener("resize", sync, { passive: true });
  /* Fonts landing late change where the clamp falls. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(sync);
  };
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  "use strict";

  /* ---------- gallery ---------- */
  const mainImg = document.getElementById("galleryImage");
  const thumbs = Array.from(document.querySelectorAll("#galleryThumbs button"));
  let galleryIndex = 0;

  function applySlide(n) {
    galleryIndex = n;
    mainImg.src = thumbs[galleryIndex].dataset.src;
    mainImg.classList.toggle("is-contain", thumbs[galleryIndex].dataset.fit === "contain");
    mainImg.style.objectPosition = thumbs[galleryIndex].dataset.pos || "";
    thumbs.forEach((t, i) => t.classList.toggle("is-active", i === galleryIndex));
  }
  function showImage(i, skipFade) {
    const n = (i + thumbs.length) % thumbs.length;
    if (n === galleryIndex && !skipFade) return;
    if (skipFade) { applySlide(n); return; }
    mainImg.style.opacity = "0";
    window.setTimeout(() => {
      applySlide(n);
      mainImg.style.opacity = "1";
    }, 160);
  }
  showImage(0, true);

  thumbs.forEach((t, n) => t.addEventListener("click", () => showImage(n)));
  document.getElementById("galleryPrev").addEventListener("click", () => showImage(galleryIndex - 1));
  document.getElementById("galleryNext").addEventListener("click", () => showImage(galleryIndex + 1));

  /* ---------- gallery: touch swipe (mobile) ---------- */
  const galleryMain = document.getElementById("galleryMain");
  let touchStartX = 0;
  let touchStartY = 0;
  galleryMain.addEventListener("touchstart", (e) => {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });
  galleryMain.addEventListener("touchend", (e) => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    const dy = e.changedTouches[0].clientY - touchStartY;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
      showImage(dx < 0 ? galleryIndex + 1 : galleryIndex - 1);
    }
  }, { passive: true });

  /* ---------- mobile gallery: swipeable track + pagination dots ---------- */
  const mTrack = document.getElementById("galleryMTrack");
  const mSlides = Array.from(document.querySelectorAll(".gallery__mslide"));
  const dots = Array.from(document.querySelectorAll(".gallery__dot"));
  if (mTrack && dots.length) {
    let mTicking = false;
    function syncDots() {
      const idx = Math.round(mTrack.scrollLeft / mTrack.clientWidth);
      dots.forEach((d, i) => d.classList.toggle("is-active", i === idx));
      mTicking = false;
    }
    mTrack.addEventListener("scroll", () => {
      if (!mTicking) {
        window.requestAnimationFrame(syncDots);
        mTicking = true;
      }
    }, { passive: true });
    dots.forEach((dot, i) => {
      dot.addEventListener("click", () => {
        mTrack.scrollTo({ left: i * mTrack.clientWidth, behavior: "smooth" });
      });
    });
  }

  /* ---------- purchase: two variant-backed options (membership default) + delivery ---------- */
  const planOptions = Array.from(document.querySelectorAll("#purchaseOptions .buy2-card"));
  let plan = (planOptions.find((o) => o.classList.contains("is-active")) || planOptions[0]).dataset.plan;
  let qty = 1;

  function activePlan() {
    return planOptions.find((o) => o.dataset.plan === plan);
  }
  function selectPlan(name) {
    plan = name;
    planOptions.forEach((o) => {
      const on = o.dataset.plan === name;
      o.classList.toggle("is-active", on);
      o.setAttribute("aria-checked", on ? "true" : "false");
    });
    updatePrice();
  }

  planOptions.forEach((opt) => {
    opt.addEventListener("click", () => selectPlan(opt.dataset.plan));
    opt.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); selectPlan(opt.dataset.plan); }
    });
  });

  /* ---------- delivery cadence ----------
     Release 01 is monthly only. The vertical cadence picker that used to live
     here was display-only: `frequency` never reached /reservations, while
     STRIPE_PRICE_ID bills a fixed monthly price — so selecting "Every 3
     Months" still charged monthly, and the sticky bar confirmed the wrong
     interval back to the customer. Removed with its markup rather than
     hidden, so there is nothing to accidentally re-enable. */

  /* ---------- quantity (main + sticky bar, shared state) ---------- */
  const qtyValue = document.getElementById("qtyValue");
  const qtyValueSticky = document.getElementById("qtyValueSticky");
  function decQty() { qty = Math.max(1, qty - 1); updatePrice(); }
  function incQty() { qty = Math.min(10, qty + 1); updatePrice(); }
  /* Null-guarded: the quantity selector was removed from the markup, and an
     unguarded getElementById(...).addEventListener here would throw and take
     the rest of this file down with it — gallery, plan picker, add-to-cart and
     the reservation modal all live below. `qty` stays 1 and is still sent to
     /cart/add.js unchanged. */
  const qtyMinus = document.getElementById("qtyMinus");
  const qtyPlus = document.getElementById("qtyPlus");
  if (qtyMinus) qtyMinus.addEventListener("click", decQty);
  if (qtyPlus) qtyPlus.addEventListener("click", incQty);
  const qtyMinusSticky = document.getElementById("qtyMinusSticky");
  const qtyPlusSticky = document.getElementById("qtyPlusSticky");
  if (qtyMinusSticky) qtyMinusSticky.addEventListener("click", decQty);
  if (qtyPlusSticky) qtyPlusSticky.addEventListener("click", incQty);

  function updatePrice() {
    if (qtyValue) qtyValue.textContent = qty;
    if (qtyValueSticky) qtyValueSticky.textContent = qty;
    const cta = document.getElementById("addToCart");
    const sticky = document.getElementById("stickyPrice");
    const price = parseFloat(activePlan().dataset.price);
    const isMember = plan === "membership";
    cta.disabled = false;
    cta.textContent = isMember ? "Join Pure Cartel" : "Add to Cart";
    const stickyBtnEl = document.getElementById("stickyBtn");
    if (stickyBtnEl) stickyBtnEl.textContent = isMember ? "Join Pure Cartel" : "Add to Cart";
    // Whole-dollar prices read as "$35", matching money_without_trailing_zeros.
    const money = "$" + (Number.isInteger(price) ? price : price.toFixed(2));
    const stickyTitle = document.getElementById("stickyTitle");
    const stickyMeta = document.getElementById("stickyMeta");
    if (stickyTitle) stickyTitle.textContent = isMember ? "Pure Cartel Membership" : (stickyTitle.dataset.product || "The Signature Liner");
    sticky.textContent = isMember ? money + "/month" : money + " · One-time";
    if (stickyMeta) stickyMeta.textContent = isMember ? "30 liners delivered every month" : "30 liners · ships once";
  }
  updatePrice();

  /* ---------- add to cart: real Shopify Ajax Cart API, then go to the cart ---------- */
  function addToCart(btn) {
    const planEl = activePlan();
    const variantId = planEl.dataset.variantId;
    btn.disabled = true;
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
    })
      .then((r) => {
        if (!r.ok) return r.json().then((err) => Promise.reject(err));
        return r.json();
      })
      .then(() => {
        window.location.href = window.PureCartel && window.PureCartel.cartUrl ? window.PureCartel.cartUrl : "/cart";
      })
      .catch((err) => {
        btn.disabled = false;
        console.error("Add to cart failed", err);
        alert((err && err.description) || "Couldn't add this to your cart — please try again.");
      });
  }

  const atcBtn = document.getElementById("addToCart");
  const stickyBtn = document.getElementById("stickyBtn");
  const relFull = atcBtn.dataset.relFull === "true";

  /* Membership goes through the reservation flow (no immediate charge).
     One-Time is a real purchase, so it still adds to cart normally. */
  function primaryAction(btn) {
    if (plan === "membership") {
      if (relFull) return;
      openReservation();
    } else {
      addToCart(btn);
    }
  }
  atcBtn.addEventListener("click", () => primaryAction(atcBtn));
  stickyBtn.addEventListener("click", () => primaryAction(stickyBtn));

  /* If Release 01 is full, lock the membership CTA */
  function syncReserveLock() {
    if (relFull && plan === "membership") {
      atcBtn.disabled = true;
      atcBtn.textContent = "Release 01 is Full";
      stickyBtn.disabled = true;
    } else {
      atcBtn.disabled = false;
      stickyBtn.disabled = false;
    }
  }
  syncReserveLock();
  planOptions.forEach((opt) => opt.addEventListener("click", syncReserveLock));

  /* ---------- Release 01 counter: thousands separators (display only) ---------- */
  document.querySelectorAll(".rel01 [data-count]").forEach((el) => {
    const n = parseInt(el.dataset.count, 10);
    if (!isNaN(n)) el.textContent = n.toLocaleString("en-US");
  });

  /* ---------- membership onboarding (cinematic 3-step reservation) ---------- */
  const resvModal = document.getElementById("resvModal");
  if (resvModal) {
    const flow = document.getElementById("onbFlow");
    const successState = document.getElementById("onbSuccess");
    const countEl = document.getElementById("onbCount");
    const dots = Array.from(resvModal.querySelectorAll(".onb__dot"));
    const screens = Array.from(resvModal.querySelectorAll(".onb__screen"));
    const submitBtn = document.getElementById("onbSubmit");
    const err2 = document.getElementById("onbError2");
    const err3 = document.getElementById("onbError3");
    const g = (id) => document.getElementById(id);
    const val = (id) => (g(id) ? g(id).value.trim() : "");
    let step = 1;

    function showStep(n) {
      step = n;
      screens.forEach((s) => (s.hidden = parseInt(s.dataset.step, 10) !== n));
      dots.forEach((d, i) => d.classList.toggle("is-on", i < n));
      countEl.textContent = n + " of 4";
      const first = screens.find((s) => parseInt(s.dataset.step, 10) === n).querySelector("input");
      if (first) window.setTimeout(() => first.focus(), 240);
    }

    /*
     * Analytics bridge. The theme deliberately contains NO fbq and no pixel of
     * any kind — it only announces what happened on Shopify's own event bus.
     * A Custom Pixel (Settings > Customer events) subscribes and decides what
     * to forward to Meta, which keeps ad-platform code out of the theme and
     * inside Shopify's consent-aware sandbox.
     *
     * Never throws: analytics must not be able to break the reservation.
     */
    function pcPublish(name, payload) {
      try {
        const a = window.Shopify && window.Shopify.analytics;
        if (a && typeof a.publish === "function") a.publish(name, payload || {});
      } catch (e) {
        /* analytics unavailable — the reservation carries on regardless */
      }
    }

    function openReservation() {
      flow.hidden = false;
      successState.hidden = true;
      if (err2) err2.hidden = true;
      if (err3) err3.hidden = true;
      if (err4) err4.hidden = true;
      showStep(1);
      resvModal.classList.add("is-open");
      resvModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
      /* Channel name must match the analytics.subscribe() in
         pure-cartel-custom-pixel.js exactly, or the event silently stops.
         Renamed from "pc_reservation_started" so the Meta event it produces is
         the custom ReservationStarted rather than InitiateCheckout — that
         standard event now belongs solely to Shopify checkout.

         No monetary value: nothing is charged anywhere in the reservation
         funnel. Money is reported once, on the first subscription charge. */
      pcPublish("ReservationStarted", {});
    }
    window.__openReservation = openReservation;

    function closeReservation() {
      resvModal.classList.remove("is-open");
      resvModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
    resvModal.querySelectorAll("[data-resvclose]").forEach((el) =>
      el.addEventListener("click", closeReservation)
    );
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && resvModal.classList.contains("is-open")) closeReservation();
    });

    function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

    /* ---------- billing country: ISO 3166-1 alpha-2 only ----------
       Stripe's billing_details.address.country accepts two-letter codes and
       rejects names, so a typed "United States" failed confirmCardSetup. The
       select's option values are the codes; isoCountry() is the backstop for
       anything that still arrives as a name (autofill, older markup). */
    const ISO_COUNTRIES = ("US AD AE AF AG AI AL AM AO AQ AR AS AT AU AW AX AZ BA BB BD BE BF BG BH BI BJ BL BM BN BO BQ BR BS BT BV BW BY BZ CA CC CD CF CG CH CI CK CL CM CN CO CR CU CV CW CX CY CZ DE DJ DK DM DO DZ EC EE EG EH ER ES ET FI FJ FK FM FO FR GA GB GD GE GF GG GH GI GL GM GN GP GQ GR GS GT GU GW GY HK HM HN HR HT HU ID IE IL IM IN IO IQ IR IS IT JE JM JO JP KE KG KH KI KM KN KP KR KW KY KZ LA LB LC LI LK LR LS LT LU LV LY MA MC MD ME MF MG MH MK ML MM MN MO MP MQ MR MS MT MU MV MW MX MY MZ NA NC NE NF NG NI NL NO NP NR NU NZ OM PA PE PF PG PH PK PL PM PN PR PS PT PW PY QA RE RO RS RU RW SA SB SC SD SE SG SH SI SJ SK SL SM SN SO SR SS ST SV SX SY SZ TC TD TF TG TH TJ TK TL TM TN TO TR TT TV TW TZ UA UG UM UY UZ VA VC VE VG VI VN VU WF WS YE YT ZA ZM ZW").split(" ");
    const regionName = (() => {
      try { const dn = new Intl.DisplayNames(["en"], { type: "region" }); return (c) => dn.of(c) || c; }
      catch (e) { return (c) => c; }
    })();
    const COUNTRY_ALIASES = { "usa": "US", "u.s.": "US", "u.s.a.": "US", "united states of america": "US", "america": "US", "uk": "GB", "great britain": "GB", "england": "GB" };
    function isoCountry(v) {
      const s = String(v || "").trim();
      if (!s) return null;
      if (/^[a-z]{2}$/i.test(s) && ISO_COUNTRIES.includes(s.toUpperCase())) return s.toUpperCase();
      const k = s.toLowerCase();
      if (COUNTRY_ALIASES[k]) return COUNTRY_ALIASES[k];
      const hit = ISO_COUNTRIES.find((c) => regionName(c).toLowerCase() === k);
      return hit || null;   // unknown → omit country rather than send Stripe an invalid one
    }
    (function fillCountries() {
      const sel = g("onbBillCountry");
      if (!sel || sel.tagName !== "SELECT" || sel.options.length > 1) return;
      const rest = ISO_COUNTRIES.slice(1).map((c) => [c, regionName(c)]).sort((a, b) => a[1].localeCompare(b[1]));
      rest.forEach(([code, name]) => sel.add(new Option(name, code)));
      sel.value = "US";
    })();

    /* step navigation with per-step validation */
    resvModal.querySelectorAll("[data-onb-next]").forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = parseInt(btn.dataset.onbNext, 10);
        if (target === 3) {
          if (!val("onbFirst") || !val("onbLast")) { err2.hidden = false; err2.textContent = "Please enter your first and last name."; return; }
          if (!validEmail(val("onbEmail"))) { err2.hidden = false; err2.textContent = "Please enter a valid email address."; return; }
          err2.hidden = true;
        }
        showStep(target);
      });
    });

    /* ---------- Stripe Elements: PCI-safe custom card fields + wallets ---------- */
    const PC = window.PureCartel || {};
    let stripe = null, cardNumber = null, stripeReady = false, paymentRequest = null;
    let stripeCustomerId = null;   // captured from the SetupIntent response

    function initStripe() {
      if (stripeReady) return;
      // No keys, or Stripe.js didn't load → leave the visual placeholder as-is.
      // (Reserve still files an honest no-charge reservation; no card is collected.)
      if (!PC.stripePk || !PC.setupIntentUrl || typeof window.Stripe === "undefined") return;

      stripe = window.Stripe(PC.stripePk);
      const elements = stripe.elements({
        fonts: [{ cssSrc: "https://fonts.googleapis.com/css2?family=IBM+Plex+Mono:wght@500;600;700&display=swap" }]
      });
      const style = {
        base: {
          color: "#F3F0EA",
          fontFamily: '"IBM Plex Mono", monospace',
          fontSize: "16px",   // 16px+: iOS Safari zooms into smaller inputs, iframes included
          fontWeight: "500",
          letterSpacing: "0.01em",
          "::placeholder": { color: "rgba(243,240,234,0.4)" }
        },
        invalid: { color: "#E6B4A6" }
      };
      // Clear the placeholder previews, then mount real Elements into the same containers.
      ["onbCardNumber", "onbCardExpiry", "onbCardCvc"].forEach((id) => { const el = g(id); if (el) el.innerHTML = ""; });
      // disableLink: Stripe's Link button inside the card field read "Pay",
      // which contradicts the $0-today reservation. Card entry is unchanged.
      cardNumber = elements.create("cardNumber", { style: style, showIcon: true, disableLink: true });
      const cardExpiry = elements.create("cardExpiry", { style: style });
      const cardCvc = elements.create("cardCvc", { style: style });
      cardNumber.mount("#onbCardNumber");
      cardExpiry.mount("#onbCardExpiry");
      cardCvc.mount("#onbCardCvc");
      const nameInput = g("onbCardName");
      if (nameInput) nameInput.disabled = false;
      // Swap the honest placeholder trust line for the live one.
      const tPh = g("onbTrustPh"); const tLive = g("onbTrustLive");
      if (tPh) tPh.hidden = true;
      if (tLive) tLive.hidden = false;
      stripeReady = true;

      // Apple Pay / Google Pay — replace the placeholder buttons with the real
      // Payment Request button only when the device/browser actually supports it.
      try {
        paymentRequest = stripe.paymentRequest({
          country: "US", currency: "usd",
          total: { label: "Pure Cartel Membership (saved, not charged today)", amount: 0 },
          requestPayerName: true, requestPayerEmail: true,
          /* Only the wallets the copy names. Without this, browsers with no
             Apple Pay / Google Pay fell back to Stripe Link ("Pay securely
             with link") or the browser's saved-card sheet. */
          disableWallets: ["link", "browserCard"]
        });
        const prButton = elements.create("paymentRequestButton", {
          paymentRequest: paymentRequest,
          style: { paymentRequestButton: { theme: "dark", height: "46px" } }
        });
        // Stripe reports which wallet (Apple Pay on Safari/iOS, Google Pay on
        // Chrome/Android) the device genuinely supports. The static placeholder
        // buttons were only for the pre-Stripe mock — once live, either the REAL
        // wallet button shows, or the whole wallet row (incl. the OR divider)
        // is removed. Disabled/fake buttons are never shown.
        paymentRequest.canMakePayment().then((result) => {
          const wallets = g("onbWallets");
          // Reveal the full-width wallet button ONLY when the device genuinely
          // supports Apple Pay (Safari/iOS) or Google Pay (Chrome/Android).
          if (result && wallets) {
            prButton.mount("#onbPaymentRequest");
            wallets.hidden = false;
          }
          // No supported wallet → the row stays hidden; card fields only.
        });
        paymentRequest.on("paymentmethod", (ev) => { saveCardThenReserve(ev.paymentMethod.id, ev); });
      } catch (e) { /* wallets stay hidden; card fields still work */ }
    }

    /* Create a SetupIntent on the backend, save the card (no charge), then file the reservation. */
    function saveCardThenReserve(existingPmId, prEvent) {
      const name = (val("onbFirst") + " " + val("onbLast")).trim();
      const email = val("onbEmail");
      submitBtn.disabled = true;
      submitBtn.textContent = "Securing…";

      fetch(PC.setupIntentUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: email, name: name })
      })
        .then((r) => r.json())
        .then((data) => {
          if (!data || !data.clientSecret) throw new Error("no client secret");
          // Held so the reservation can link the member to their Stripe
          // customer — without it the member record has a saved card it
          // cannot later charge.
          stripeCustomerId = data.customerId || null;
          if (existingPmId) {
            // Wallet path: confirm setup with the wallet's payment method.
            return stripe.confirmCardSetup(data.clientSecret, { payment_method: existingPmId }, { handleActions: false })
              .then((res) => { if (prEvent) prEvent.complete(res.error ? "fail" : "success"); if (res.error) throw res.error; return res.setupIntent; });
          }
          /* Card path: attach the billing address to the payment method.
             Stripe becomes the sole owner of the billing address — it is never
             sent to /reservations and never stored in our database, so there
             is exactly one copy of it. Each line is included only when it has
             a value: Stripe rejects an address object whose members are empty
             strings, and a customer who leaves the block blank must still be
             able to reserve. */
          const billing = { name: val("onbCardName") || name, email: email };
          const addr = {};
          if (val("onbBillAddress"))  addr.line1       = val("onbBillAddress");
          if (val("onbBillAddress2")) addr.line2       = val("onbBillAddress2");
          if (val("onbBillCity"))     addr.city        = val("onbBillCity");
          if (val("onbBillRegion"))   addr.state       = val("onbBillRegion");
          if (val("onbBillZip"))      addr.postal_code = val("onbBillZip");
          if (isoCountry(val("onbBillCountry"))) addr.country = isoCountry(val("onbBillCountry"));
          if (addr.line1) billing.address = addr;

          return stripe.confirmCardSetup(data.clientSecret, {
            payment_method: { card: cardNumber, billing_details: billing }
          }).then((res) => { if (res.error) throw res.error; return res.setupIntent; });
        })
        .then((setupIntent) => {
          submitReservation({
            pm: setupIntent.payment_method,
            si: setupIntent.id,
            customerId: stripeCustomerId
          });
        })
        .catch((e) => {
          if (prEvent) { try { prEvent.complete("fail"); } catch (x) {} }
          submitBtn.disabled = false;
          submitBtn.textContent = "Reserve Membership · $0 Today";
          err3.hidden = false;
          err3.textContent = (e && e.message) || "Payment couldn't be secured. Please check your card and try again.";
        });
    }

    /* ------------------------------------------------------------
       Record the reservation in the Pure Cartel database.

       This is the real write path: it allocates the founding member number,
       creates the member record, and starts the activity log. The contact-form
       email below remains as the fallback when the API is not configured, so
       the flow keeps working exactly as it does today until the backend is
       deployed and its URL is set in theme settings.
       ------------------------------------------------------------ */
    /*
     * Meta's own first-party cookies. _fbp identifies the browser, _fbc carries
     * the click id from an ad. Forwarding them lets the server-side Conversions
     * API event be stitched to the same person and session, which is the single
     * largest lever on match quality. Neither is user data — they are Meta
     * identifiers — so they are sent as-is and never hashed.
     */
    function readCookie(name) {
      const m = document.cookie.match("(^|;)\\s*" + name + "\\s*=\\s*([^;]+)");
      return m ? decodeURIComponent(m[2]) : null;
    }

    function postToMembershipApi(pay) {
      if (!PC.membershipApiUrl) return Promise.resolve(null);

      /* No address of either kind is sent here any more.
         · shipping — not collected at reservation; the member adds it from
           their dashboard, and it is written to shipping_profiles.
         · billing  — already attached to the Stripe PaymentMethod above.
           Sending a second copy would create a second source of truth for the
           same fact, and the previous one was only ever written into an events
           payload that nothing read back. */
      const body = {
        fbp: readCookie("_fbp"),
        fbc: readCookie("_fbc"),
        sourceUrl: window.location.href,
        email: val("onbEmail"),
        firstName: val("onbFirst"),
        lastName: val("onbLast"),
        phone: val("onbPhone"),
        releaseId: "01",
        stripeCustomerId: (pay && pay.customerId) || null,
        stripePaymentMethodId: (pay && pay.pm) || null,
        stripeSetupIntentId: (pay && pay.si) || null
      };

      return fetch(PC.membershipApiUrl.replace(/\/$/, "") + "/reservations", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      })
        .then((r) => r.json().then((j) => ({ status: r.status, json: j })))
        .then((res) => {
          if (res.status === 201) return res.json;
          // A duplicate is not a failure from the customer's point of view —
          // they already hold a membership, so carry on to the account step.
          if (res.status === 409 && res.json.error === "already_reserved") return res.json;
          throw new Error((res.json && res.json.message) || "reservation_failed");
        });
    }

    /* File the real, no-charge reservation (optionally with the saved-card reference). */
    function submitReservation(pay) {
      /* Billing address as typed, for the contact-form fallback only. The
         shipping address is deliberately absent: it is not collected at
         reservation any more, and the member supplies it from their dashboard.
         When the membership API is configured this whole email is skipped. */
      const billAddr =
        [val("onbBillAddress"), val("onbBillAddress2"),
         val("onbBillCity") + ", " + val("onbBillRegion") + " " + val("onbBillZip"),
         val("onbBillCountry")].filter(Boolean).join("\n") || "Not provided";
      const cardRef = pay
        ? "Saved card (Stripe): payment_method " + pay.pm + " · setup_intent " + pay.si + "\n"
        : "No card captured (Stripe not configured at time of reservation).\n";
      const body = new URLSearchParams();
      body.append("form_type", "contact");
      body.append("utf8", "✓");
      body.append("contact[name]", val("onbFirst") + " " + val("onbLast"));
      body.append("contact[email]", val("onbEmail"));
      body.append("contact[phone]", val("onbPhone"));
      body.append("contact[body]",
        "PURE CARTEL — RELEASE 01 MEMBERSHIP RESERVATION (status: pending acceptance)\n\n" +
        "Name: " + val("onbFirst") + " " + val("onbLast") + "\n" +
        "Email: " + val("onbEmail") + "\n" +
        "Phone: " + (val("onbPhone") || "—") + "\n\n" +
        "Billing address:\n" + billAddr + "\n\n" +
        "Shipping address: collected separately from the membership dashboard.\n\n" +
        cardRef +
        "No charge taken today. Charge $35/month only after accepting this member for Release 01.");

      /* The membership API is the durable record when configured. The email
         fallback is used only when it is not — and is deliberately not sent
         alongside it, since that email carries the Stripe payment_method id
         and an inbox is a poor place for it. */
      const record = PC.membershipApiUrl
        ? postToMembershipApi(pay)
        : fetch("/contact#contact_form", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            body: body.toString()
          });

      record
        .then((result) => {
          /* Carry the real reservation into the portal. The API returns this
             customer's actual founding number, status and reservation date;
             without this the portal would open on the placeholder rendered by
             Liquid and show them a number that is not theirs. */
          if (result && result.memberNumber && window.PureCartel.membership) {
            window.PureCartel.membership.setMember({
              memberNumber: result.memberNumber,
              status: result.status || "pending",
              reservedOn: result.reservedOn || null,
              release: result.release || "Release 01",
              tier: result.tier || "Member",
              monthlyPrice: result.monthlyPrice || "$35/month",
              journey: result.journey || undefined,
              /* The $20 member credit is issued inside the reservation and
                 returned preformatted by the API ("$20.00"). Without passing it
                 on, the portal kept its Liquid placeholder and showed $0.00 to
                 a member who had just been credited. Omitted when absent (e.g.
                 a 409 already_reserved) so the portal's own fallback applies. */
              memberCredit: result.memberCredit || undefined,
              creditCents: typeof result.creditCents === "number" ? result.creditCents : undefined,
              email: val("onbEmail")
            });
          }

          /* Announce the conversion — but ONLY for a genuinely new reservation.
             A repeat submission returns 409 already_reserved, which this flow
             deliberately treats as success so the customer still reaches their
             account. That response carries no metaEventId, so keying on it is
             what stops one person producing two Leads.

             metaEventId is minted server-side and the Conversions API sends the
             same value, so Meta collapses the browser and server events into
             one. */
          if (result && result.metaEventId) {
            pcPublish("pc_reservation_completed", {
              eventId: result.metaEventId,
              memberNumber: result.memberNumber
            });
          }
          enterAccountStep();
        })
        .catch((e) => {
          submitBtn.disabled = false;
          submitBtn.textContent = "Reserve Membership · $0 Today";
          err3.hidden = false;
          err3.textContent = (e && e.message) || "Something went wrong. Please try again.";
        });
    }

    /* ============================================================
       MEMBERSHIP FLOW REFINEMENT — account step.
       Nothing below touches Stripe, the SetupIntent, or the reservation
       submit above. Step 4 runs only AFTER the reservation has already
       succeeded, so it can never block or repeat a reservation.

       The billing "same as shipping" collapse that used to live here was
       removed with its markup: the billing block is now always visible,
       because there is no shipping address at reservation for it to mirror.
       ============================================================ */

    /* step 4 — membership account (email is already known; never ask twice) */
    const acctSubmit = g("onbAcctSubmit");
    const err4 = g("onbError4");

    function enterAccountStep() {
      const emailField = g("onbAcctEmail");
      if (emailField) emailField.value = val("onbEmail");
      showStep(4);
    }

    if (acctSubmit) {
      acctSubmit.addEventListener("click", () => {
        /* The password fields and their in-browser validation were removed with
           the markup they guarded. They had to go together: with the inputs
           gone, the old `pw.length < 8` check would read "" and refuse to
           advance, stranding the customer on step 4 after their reservation had
           already been filed. The password was never transmitted or stored, so
           nothing downstream depended on it.

           Sign-in is passwordless: the Membership page emails a six-digit code
           to this address. No account-creation call belongs here. */
        if (err4) err4.hidden = true;

        /* Transition into the Membership Portal, which is embedded in this same
           sheet — no navigation, and no dependency on a /pages/membership route
           existing. The portal becomes the customer's welcome experience. */
        const portal = g("onbPortal");
        if (portal) {
          acctSubmit.disabled = true;
          acctSubmit.textContent = "Opening Membership…";

          /* Carried for the day a dedicated portal route exists. Continuity
             flag ONLY — not a session, grants nothing, cleared on sign out. */
          try {
            window.sessionStorage.setItem("pc_onboarding_complete", "1");
            window.sessionStorage.setItem("pc_onboarding_email", val("onbEmail"));
          } catch (e) { /* private mode — nothing depends on this */ }

          // cross-fade the flow out and the portal in, on the sheet's own easing
          const sheet = resvModal.querySelector(".onb__sheet");
          flow.style.transition = "opacity 0.28s ease";
          flow.style.opacity = "0";
          window.setTimeout(() => {
            flow.hidden = true;
            flow.style.opacity = "";
            flow.style.transition = "";
            portal.hidden = false;
            if (sheet) sheet.scrollTop = 0;
            // let the portal run its own entrance + counter
            if (PC.membership && PC.membership.enter) PC.membership.enter();
          }, 300);
          return;
        }
        // Portal markup missing → original reservation confirmation.
        flow.hidden = true;
        successState.hidden = false;
      });
    }

    /* final submit — save card if Stripe is configured, then reserve (always no charge today) */
    submitBtn.addEventListener("click", () => {
      /* No address gate. The shipping fields this used to guard are gone, and
         the gate lived only on this button — the wallet handler called
         saveCardThenReserve directly and skipped it, so Apple Pay could
         already file a reservation with an empty address. Card and wallet now
         follow the same path, and neither is blocked on an address the
         reservation no longer asks for. */
      err3.hidden = true;
      if (stripeReady) {
        saveCardThenReserve(null, null);
      } else {
        submitBtn.disabled = true;
        submitBtn.textContent = "Reserving…";
        submitReservation(null);
      }
    });

    // Silently wake the backend the moment onboarding opens, so a cold (sleeping)
    // free-tier dyno is warm by the time the customer reaches the payment submit.
    // Invisible; changes nothing in the UI or flow.
    function warmBackend() {
      if (!PC.setupIntentUrl) return;
      try {
        const origin = new URL(PC.setupIntentUrl).origin;
        fetch(origin + "/", { method: "GET", mode: "no-cors", cache: "no-store" }).catch(function () {});
      } catch (e) { /* no-op */ }
    }

    // Initialise Stripe once the modal is first opened (and Stripe.js has had time to load).
    const _open = window.__openReservation;
    window.__openReservation = function () { _open(); warmBackend(); window.setTimeout(initStripe, 60); };

    /* Story Page hand-off. Its CTAs link here with ?reserve=1, and the sheet
       opens on arrival through the same entry point as the Join button — so
       the visitor never has to find Join again. Nothing in the reservation
       flow changes: the sheet, validation, Stripe, the API and the
       ReservationStarted / Lead events behave exactly as on a Join click.
       Membership only: if a different plan is somehow active, do nothing. */
    try {
      if (new URLSearchParams(window.location.search).get("reserve") === "1" && plan === "membership") {
        window.setTimeout(window.__openReservation, 300);
      }
    } catch (e) { /* no-op: the page works exactly as before */ }
  }
  function openReservation() { if (window.__openReservation) window.__openReservation(); }

  /* ---------- sticky ATC ----------
     Phones and tablets (≤960px, where the product grid stacks): visible from
     first paint, because the buy box sits below the first viewport there and
     this bar is the only place the membership, price and CTA can be on the
     first screen. Wider screens keep the original show-after-~300px reveal. */
  const stickyBar = document.getElementById("stickyAtc");
  const stickyAlways = window.matchMedia("(max-width: 960px)");
  let stickyTicking = false;
  function updateStickyVisibility() {
    stickyBar.classList.toggle("is-visible", stickyAlways.matches || window.scrollY > 300);
    stickyTicking = false;
  }
  if (stickyAlways.addEventListener) stickyAlways.addEventListener("change", updateStickyVisibility);
  window.addEventListener("scroll", () => {
    if (!stickyTicking) {
      window.requestAnimationFrame(updateStickyVisibility);
      stickyTicking = true;
    }
  }, { passive: true });
  updateStickyVisibility();

  /* ---------- customer reviews: helpful / sort ---------- */
  const reviewList = document.getElementById("reviewList");
  if (reviewList) {
    reviewList.addEventListener("click", (e) => {
      const btn = e.target.closest(".revrow__helpful");
      if (!btn) return;
      const row = btn.closest(".revrow");
      let n = parseInt(row.dataset.helpful, 10) || 0;
      if (btn.classList.contains("is-voted")) {
        n -= 1;
        btn.classList.remove("is-voted");
      } else {
        n += 1;
        btn.classList.add("is-voted");
      }
      row.dataset.helpful = n;
      btn.textContent = "Helpful (" + n + ")";
    });

    const sortSel = document.getElementById("reviewSort");
    if (sortSel) {
      sortSel.addEventListener("change", () => {
        const rows = Array.from(reviewList.children);
        rows.sort((a, b) => {
          if (sortSel.value === "helpful") {
            return (b.dataset.helpful || 0) - (a.dataset.helpful || 0);
          }
          if (sortSel.value === "highest") return 0; // all 5★ here
          return new Date(b.dataset.date) - new Date(a.dataset.date);
        });
        rows.forEach((r) => reviewList.appendChild(r));
      });
    }
  }

  /* ---------- single-open accordions per group ---------- */
  document.querySelectorAll(".faq__list, .buybox").forEach((group) => {
    group.addEventListener("toggle", (e) => {
      if (!e.target.open) return;
      group.querySelectorAll("details[open]").forEach((d) => {
        if (d !== e.target) d.open = false;
      });
    }, true);
  });

  /* ---------- write a review: modal (frontend only, no backend yet) ---------- */
  const reviewModal = document.getElementById("reviewModal");
  if (reviewModal) {
    const openBtn = document.getElementById("writeReviewBtn");
    const closeBtn = document.getElementById("reviewModalClose");
    const backdrop = document.getElementById("reviewModalBackdrop");
    const body = document.getElementById("reviewModalBody");
    const success = document.getElementById("reviewModalSuccess");
    const starBtns = Array.from(document.querySelectorAll(".review-stars__btn"));
    const nameInput = document.getElementById("reviewName");
    const textInput = document.getElementById("reviewText");
    const photoInput = document.getElementById("reviewPhotos");
    const uploadBtn = document.getElementById("reviewUploadBtn");
    const thumbsWrap = document.getElementById("reviewThumbs");
    const submitBtn = document.getElementById("reviewSubmitBtn");
    const doneBtn = document.getElementById("reviewModalDone");

    let rating = 0;
    let photos = [];

    function paintStars() {
      starBtns.forEach((b) => {
        const on = parseInt(b.dataset.star, 10) <= rating;
        b.classList.toggle("is-on", on);
        b.setAttribute("aria-checked", on ? "true" : "false");
      });
    }
    starBtns.forEach((b) => {
      b.addEventListener("click", () => {
        rating = parseInt(b.dataset.star, 10);
        paintStars();
      });
    });

    function renderThumbs() {
      thumbsWrap.innerHTML = "";
      photos.forEach((p, i) => {
        const fig = document.createElement("div");
        fig.className = "review-thumb";
        fig.innerHTML = '<img src="' + p.url + '" alt="" /><button type="button" class="review-thumb__remove" aria-label="Remove photo">&times;</button>';
        fig.querySelector("button").addEventListener("click", () => {
          URL.revokeObjectURL(p.url);
          photos.splice(i, 1);
          renderThumbs();
        });
        thumbsWrap.appendChild(fig);
      });
    }
    uploadBtn.addEventListener("click", () => photoInput.click());
    photoInput.addEventListener("change", () => {
      Array.from(photoInput.files).forEach((file) => {
        photos.push({ file: file, url: URL.createObjectURL(file) });
      });
      photoInput.value = "";
      renderThumbs();
    });

    function resetForm() {
      rating = 0;
      photos.forEach((p) => URL.revokeObjectURL(p.url));
      photos = [];
      paintStars();
      renderThumbs();
      nameInput.value = "";
      textInput.value = "";
      body.hidden = false;
      success.hidden = true;
    }

    function openModal() {
      reviewModal.classList.add("is-open");
      reviewModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    function closeModal() {
      reviewModal.classList.remove("is-open");
      reviewModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
      resetForm();
    }

    if (openBtn) openBtn.addEventListener("click", openModal);
    closeBtn.addEventListener("click", closeModal);
    backdrop.addEventListener("click", closeModal);
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && reviewModal.classList.contains("is-open")) closeModal();
    });

    submitBtn.addEventListener("click", () => {
      if (rating === 0) {
        starBtns[0].closest(".review-field").classList.add("has-error");
        return;
      }
      body.hidden = true;
      success.hidden = false;
    });
    doneBtn.addEventListener("click", closeModal);
  }

  /* ---------- how we compare: modal (no page refresh) ---------- */
  const compareModal = document.getElementById("compareModal");
  if (compareModal) {
    const cOpen = document.getElementById("compareOpen");
    const cClose = document.getElementById("compareClose");
    function openCompare() {
      compareModal.classList.add("is-open");
      compareModal.setAttribute("aria-hidden", "false");
      document.body.style.overflow = "hidden";
    }
    function closeCompare() {
      compareModal.classList.remove("is-open");
      compareModal.setAttribute("aria-hidden", "true");
      document.body.style.overflow = "";
    }
    if (cOpen) cOpen.addEventListener("click", openCompare);
    if (cClose) cClose.addEventListener("click", closeCompare);
    compareModal.querySelectorAll("[data-compareclose]").forEach((el) =>
      el.addEventListener("click", closeCompare)
    );
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && compareModal.classList.contains("is-open")) closeCompare();
    });
  }
})();
